import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X, Cookie, Settings } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true, // Always true, non modificabile
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    // Verifica se l'utente ha già dato il consenso
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Mostra il banner dopo 1 secondo
      setTimeout(() => setShowBanner(true), 1000);
    } else {
      // Carica le preferenze salvate
      const savedPrefs = JSON.parse(consent);
      setPreferences(savedPrefs);
      loadScripts(savedPrefs);
    }
  }, []);

  const loadScripts = (prefs) => {
    // Aggiorna Google Consent Mode
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'ad_storage': prefs.marketing ? 'granted' : 'denied',
        'analytics_storage': prefs.analytics ? 'granted' : 'denied',
        'ad_user_data': prefs.marketing ? 'granted' : 'denied',
        'ad_personalization': prefs.marketing ? 'granted' : 'denied'
      });
      console.log('Google Consent updated:', { marketing: prefs.marketing, analytics: prefs.analytics });
    }

    // Google Analytics (se hai un GA4 ID separato)
    if (prefs.analytics) {
      console.log('Google Analytics consent granted');
    }

    // Meta Pixel (Facebook) - Inserisci qui il tuo Pixel ID quando disponibile
    if (prefs.marketing) {
      // !function(f,b,e,v,n,t,s)
      // {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      // n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      // if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      // n.queue=[];t=b.createElement(e);t.async=!0;
      // t.src=v;s=b.getElementsByTagName(e)[0];
      // s.parentNode.insertBefore(t,s)}(window, document,'script',
      // 'https://connect.facebook.net/en_US/fbevents.js');
      // fbq('init', 'YOUR_PIXEL_ID');
      // fbq('track', 'PageView');
      
      console.log('Meta Pixel consent granted');
    }
  };

  const handleAcceptAll = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      marketing: true
    };
    setPreferences(allAccepted);
    localStorage.setItem('cookieConsent', JSON.stringify(allAccepted));
    loadScripts(allAccepted);
    setShowBanner(false);
  };

  const handleRejectAll = () => {
    const onlyNecessary = {
      necessary: true,
      analytics: false,
      marketing: false
    };
    setPreferences(onlyNecessary);
    localStorage.setItem('cookieConsent', JSON.stringify(onlyNecessary));
    setShowBanner(false);
  };

  const handleSavePreferences = () => {
    localStorage.setItem('cookieConsent', JSON.stringify(preferences));
    loadScripts(preferences);
    setShowBanner(false);
    setShowSettings(false);
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Cookie Banner */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-t border-slate-200 shadow-2xl shadow-slate-900/10">
        <div className="max-w-7xl mx-auto px-6 py-5">
          {!showSettings ? (
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="flex-1">
                <p className="text-sm text-slate-600">
                  Utilizziamo cookie tecnici, analitici e di marketing per migliorare la tua esperienza.{' '}
                  <a href="/privacy-policy" className="text-[#FF5722] underline hover:text-[#FF7043]">Privacy Policy</a>
                  {' '}e{' '}
                  <a href="/cookie-policy" className="text-[#FF5722] underline hover:text-[#FF7043]">Cookie Policy</a>.
                </p>
              </div>
              <div className="flex flex-wrap gap-2">
                <Button onClick={() => setShowSettings(true)} variant="outline" className="border-slate-200 text-slate-700 hover:bg-slate-50 text-sm h-9 gap-1.5">
                  <Settings className="w-3.5 h-3.5" />
                  Personalizza
                </Button>
                <Button onClick={handleRejectAll} variant="outline" className="border-slate-200 text-slate-700 hover:bg-slate-50 text-sm h-9">
                  Rifiuta
                </Button>
                <Button onClick={handleAcceptAll} className="bg-[#FF5722] hover:bg-[#FF7043] text-white text-sm h-9">
                  Accetta tutto
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-semibold text-slate-900">Preferenze Cookie</h3>
                <button onClick={() => setShowSettings(false)} className="p-1.5 hover:bg-slate-100 rounded-full">
                  <X className="w-4 h-4 text-slate-600" />
                </button>
              </div>
              <div className="space-y-3 mb-5">
                <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                  <div>
                    <h4 className="text-slate-900 text-sm font-medium">Cookie Necessari</h4>
                    <p className="text-xs text-slate-500">Essenziali per il funzionamento del sito.</p>
                  </div>
                  <input type="checkbox" checked={true} disabled className="w-4 h-4" />
                </div>
                <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                  <div>
                    <h4 className="text-slate-900 text-sm font-medium">Cookie Analitici</h4>
                    <p className="text-xs text-slate-500">Google Analytics per migliorare l'esperienza.</p>
                  </div>
                  <input type="checkbox" checked={preferences.analytics} onChange={(e) => setPreferences({...preferences, analytics: e.target.checked})} className="w-4 h-4 cursor-pointer" />
                </div>
                <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                  <div>
                    <h4 className="text-slate-900 text-sm font-medium">Cookie di Marketing</h4>
                    <p className="text-xs text-slate-500">Google Ads e Meta per pubblicita pertinenti.</p>
                  </div>
                  <input type="checkbox" checked={preferences.marketing} onChange={(e) => setPreferences({...preferences, marketing: e.target.checked})} className="w-4 h-4 cursor-pointer" />
                </div>
              </div>
              <div className="flex gap-2 justify-end">
                <Button onClick={handleRejectAll} variant="outline" className="border-slate-200 text-slate-700 hover:bg-slate-50 text-sm h-9">Rifiuta</Button>
                <Button onClick={handleSavePreferences} className="bg-[#FF5722] hover:bg-[#FF7043] text-white text-sm h-9">Salva preferenze</Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CookieBanner;
